import { TR_ACCESSIBILITY_BUTTON_MOVE_DOWN, TR_ACCESSIBILITY_BUTTON_MOVE_RIGHT, TR_ACCESSIBILITY_BUTTON_MOVE_LEFT, TR_ACCESSIBILITY_BUTTON_MOVE_UP, TR_ACCESSIBILITY_BUTTON_ROTATE_DOWN, TR_ACCESSIBILITY_BUTTON_ROTATE_LEFT, TR_ACCESSIBILITY_BUTTON_ROTATE_RIGHT, TR_ACCESSIBILITY_BUTTON_ROTATE_UP, TR_ACCESSIBILITY_BUTTON_ZOOM_IN, TR_ACCESSIBILITY_BUTTON_ZOOM_OUT, } from './translations';
const TRUCK_RIGHT_BUTTON = {
    name: 'truckRight',
    translation: TR_ACCESSIBILITY_BUTTON_MOVE_RIGHT,
    action: {
        function: 'truck',
        settings: [-0.01, 0],
    },
    icon: {
        name: 'arrow-left',
        class: 'rtrtw:rotate-180',
    },
};
const TRUCK_UP_BUTTON = {
    name: 'truckUp',
    translation: TR_ACCESSIBILITY_BUTTON_MOVE_UP,
    action: {
        function: 'truck',
        settings: [0, 0.01],
    },
    icon: {
        name: 'arrow-left',
        class: 'rtrtw:rotate-90',
    },
};
const TRUCK_LEFT_BUTTON = {
    name: 'truckLeft',
    translation: TR_ACCESSIBILITY_BUTTON_MOVE_LEFT,
    action: {
        function: 'truck',
        settings: [0.01, 0],
    },
    icon: {
        name: 'arrow-left',
    },
};
const TRUCK_DOWN_BUTTON = {
    name: 'truckDown',
    translation: TR_ACCESSIBILITY_BUTTON_MOVE_DOWN,
    action: {
        function: 'truck',
        settings: [0, -0.01],
    },
    icon: {
        name: 'arrow-left',
        class: 'rtrtw:-rotate-90',
    },
};
const ROTATE_LEFT_BUTTON = {
    name: 'rotateLeft',
    translation: TR_ACCESSIBILITY_BUTTON_ROTATE_LEFT,
    action: {
        function: 'rotate',
        settings: [0.17, 0],
    },
    icon: {
        name: 'rotate-left',
    },
    keyboard: 'ArrowLeft',
};
const ROTATE_RIGHT_BUTTON = {
    name: 'rotateRight',
    translation: TR_ACCESSIBILITY_BUTTON_ROTATE_RIGHT,
    action: {
        function: 'rotate',
        settings: [-0.17, 0],
    },
    icon: {
        name: 'rotate-left',
        class: 'rtrtw:-scale-y-[1] rtrtw:rotate-180',
    },
    keyboard: 'ArrowRight',
};
const ROTATE_DOWN_BUTTON = {
    name: 'rotateDown',
    translation: TR_ACCESSIBILITY_BUTTON_ROTATE_DOWN,
    action: {
        function: 'rotate',
        settings: [0, -0.17],
    },
    icon: {
        name: 'rotate-left',
        class: 'rtrtw:-scale-y-[1] rtrtw:-rotate-90',
    },
    keyboard: 'ArrowDown',
};
const ROTATE_UP_BUTTON = {
    name: 'rotateUp',
    translation: TR_ACCESSIBILITY_BUTTON_ROTATE_UP,
    action: {
        function: 'rotate',
        settings: [0, 0.17],
    },
    icon: {
        name: 'rotate-left',
        class: 'rtrtw:rotate-90',
    },
    keyboard: 'ArrowUp',
};
const DOLLY_IN_BUTTON = {
    name: 'dollyIn',
    translation: TR_ACCESSIBILITY_BUTTON_ZOOM_IN,
    action: {
        function: 'dolly',
        settings: [0.1],
    },
    icon: {
        name: 'dolly-in',
    },
    keyboard: '+',
};
const DOLLY_OUT_BUTTON = {
    name: 'dollyOut',
    translation: TR_ACCESSIBILITY_BUTTON_ZOOM_OUT,
    action: {
        function: 'dolly',
        settings: [-0.1],
    },
    icon: {
        name: 'dolly-out',
    },
    keyboard: '-',
};
export const ACCESSIBILITY_AVAILABLE_BUTTONS = [
    TRUCK_RIGHT_BUTTON,
    TRUCK_UP_BUTTON,
    TRUCK_LEFT_BUTTON,
    TRUCK_DOWN_BUTTON,
    ROTATE_RIGHT_BUTTON,
    ROTATE_UP_BUTTON,
    ROTATE_LEFT_BUTTON,
    ROTATE_DOWN_BUTTON,
    DOLLY_IN_BUTTON,
    DOLLY_OUT_BUTTON,
];
